import * as React from 'react';
import * as styles from './styles.css';

import { Responsive, ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';

export interface IFeatureProps {
  testid: string;
  headerText: string;
  subheaderText: string;
  icon: string;
}

export const Feature: React.FC<IFeatureProps> = ({ testid, headerText, subheaderText, icon }) => {
  return (
    <div className={styles['feature']}>
      <Responsive desktop>
        <div className={styles['icon']}>
          <img src={icon} />
        </div>
      </Responsive>
      <div className={styles['content']}>
        <ArticleHeading2 data-testid={`Feature-${testid}`} color="text-inverted-default">
          {headerText}
        </ArticleHeading2>
        <ArticleParagraph1 color="text-inverted-default">{subheaderText}</ArticleParagraph1>
      </div>
    </div>
  );
};
